<template>
    <section class="app flex items-center justify-center">
        <div class="app-content">
            <div class="flex items-center">
                <div class="app-side flex items-center justify-center text-slate-100">
                    <div class="text-center" v-if="name === 'suit'">
                        <img src="@/assets/images/-layout/icon/suit.png" alt="" />
                        <h3>套 卷 测 试</h3>
                    </div>
                    <div class="text-center" v-if="name === 'suit:record'">
                        <img src="@/assets/images/-layout/icon/record.png" alt="" />
                        <h3>套 卷 记 录</h3>
                        <p class="mt-0.5 ps-8 pe-8">查看“套卷测试”及“统一考试”记录</p>
                    </div>
                    <div class="text-center" v-if="name === 'special:record' || name === 'special:success'">
                        <img src="@/assets/images/-layout/icon/special-record.png" alt="" />
                        <h3>专 题 记 录</h3>
                    </div>
                    <div class="text-center" v-if="name === 'my:password'">
                        <img src="@/assets/images/-layout/icon/password.png" alt="" />
                        <h3>修 改 密 码</h3>
                    </div>
                </div>
                <div class="app-main">
                    <router-view v-slot="{ Component }">
                        <transition name="fade-transform" mode="out-in">
                            <component :is="Component"></component>
                        </transition>
                    </router-view>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

import { computed } from "vue";
import router from "@/router";
import { get } from "lodash-es";

const name = computed(() => get(router.currentRoute.value, 'meta.name'))
</script>

<style lang="less" scoped>
.app {
    height: calc(100vh - 86px);
    background-image: url('../../assets/images/-layout/bg-main.png');
    background-position: 50% 100%;
    background-repeat: no-repeat;
    min-height: 630px;
    width: 100%;
    &-content {
        width: 100%;
        min-height: 600px;
        background-image: url('../../assets/images/-layout/bg-app.png');
        background-repeat: no-repeat;
        position: relative;
        background-size: cover;
    }
    &-side {
        width: 182px;
        height: 585px;
        img {
            max-width: 50px;
            display: inline-block;
        }
        h3 {
            font-size: 20px;
            font-weight: bold;
            margin-top: 0.4rem;
        }
        p {
            font-size: 12px;
        }
    }

    &-main {
        height: 538px;
        box-sizing: border-box;
        padding-top: 15px;
        width: 100%;
        max-width: 860px;
        padding-left: 15px;
    }
}

</style>
